import { Button } from "react-bootstrap";
import { DateHelper, StringHelper } from "../../../../../helper";
import { requestTypes } from "../../../../../constants";
import classNames from "classnames";
import { FontFa } from "../../../../../components";
import { transform } from "../../monthly-training-plan-summary/utils/transform";
import { useSteps } from "../../../../../hook";
import { MTPExcelJSService } from "../services/MTPExcelJS.service";

export const useMTPColumns = () => {
  const { approve } = useSteps();

  const columns = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
    },
    {
      title: "Người tạo",
      dataIndex: "eCreatedBy",
      key: "eCreatedBy",
      render: (text: string) =>
        StringHelper.verticalBarSplit<string[]>(text)[1],
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: (text: string) => (
        <div className="flag success">{requestTypes[text]}</div>
      ),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render: (text: string, record: any = {}) => {
        const { status } = approve(record?.eApprovalProcess);
        return (
          <div className={classNames("flag", status.flag)}>{status.label}</div>
        );
      },
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <Button
          title="Xuất file"
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
            const items = transform([record]);
            const mtpInstance = new MTPExcelJSService();
            mtpInstance.create(items);
            mtpInstance.download(`Bảng kế hoạch đào tạo tháng`);
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];
  return { columns };
};
